module.exports = __webpack_public_path__ + "img/7.76509e9f.jpg";